var _path, _path2, _rect, _path3, _rect2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyNavIcon = function SvgSurveyNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M16 3H6c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M14 2H8c-.55 0-1 .45-1 1v1h8V3c0-.55-.45-1-1-1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 6,
    y: 8,
    fill: "#FBD15D",
    rx: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M11 9.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5s-.22.5-.5.5h-4a.5.5 0 0 1-.5-.5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 6,
    y: 13,
    fill: "#EA3556",
    rx: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M11 14.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5s-.22.5-.5.5h-4a.5.5 0 0 1-.5-.5"
  })));
};
export default SvgSurveyNavIcon;